import { render, staticRenderFns } from "./statusSwitch.vue?vue&type=template&id=0846d526&"
import script from "./statusSwitch.vue?vue&type=script&lang=js&"
export * from "./statusSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports